import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enCommon from './locales/en/common.json';
import enInspection from './locales/en/inspection.json';
import enHelp from './locales/en/help.json';
import esCommon from './locales/es/common.json';
import esInspection from './locales/es/inspection.json';
import esHelp from './locales/es/help.json';

export const supportedLanguages = ['en', 'es'] as const;
export type SupportedLanguage = (typeof supportedLanguages)[number];

const resources = {
  en: {
    common: enCommon,
    inspection: enInspection,
    help: enHelp,
  },
  es: {
    common: esCommon,
    inspection: esInspection,
    help: esHelp,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'inspection', 'help'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'preferred_locale',
      caches: ['localStorage'],
    },
  });

export default i18n;
